var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPostquantum(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H28C34.3513 0.5 39.5 5.64873 39.5 12V28C39.5 34.3513 34.3513 39.5 28 39.5H12C5.64873 39.5 0.5 34.3513 0.5 28V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    fill: "url(#paint0_linear_19_2822)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H28C34.3513 0.5 39.5 5.64873 39.5 12V28C39.5 34.3513 34.3513 39.5 28 39.5H12C5.64873 39.5 0.5 34.3513 0.5 28V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    stroke: "url(#paint1_linear_19_2822)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_2822)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_2822",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 8H8V32H32V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_2822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0001 16.5C30.0001 19.76 27.6001 22.45 24.4801 22.92V22.86C24.1701 18.98 21.0201 15.83 17.1101 15.52H17.0801C17.5501 12.4 20.2401 10 23.5001 10C27.0901 10 30.0001 12.91 30.0001 16.5Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.98 22.98C22.73 19.81 20.19 17.27 17.02 17.02C16.85 17.01 16.67 17 16.5 17C12.91 17 10 19.91 10 23.5C10 27.09 12.91 30 16.5 30C20.09 30 23 27.09 23 23.5C23 23.33 22.99 23.15 22.98 22.98ZM17.38 24.38L16.5 26L15.62 24.38L14 23.5L15.62 22.62L16.5 21L17.38 22.62L19 23.5L17.38 24.38Z",
    fill: "#34D399"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19_2822",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19_2822",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 34.7917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_2822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPostquantum);
export default __webpack_public_path__ + "static/media/icon-postquantum.045bc28a4396ba77ab83dd7bfa4278c6.svg";
export { ForwardRef as ReactComponent };